import {Hydra} from '../generic/hydra';

import {ActivityInterface} from './Activity';
import {UtilisateurInterface} from './Utilisateur';
import {ActivityComment as ActivityCommentBaseInterface} from '../../interface/api/ActivityComment';

export type ActivityCommentInterface = ActivityCommentBaseInterface;

export class ActivityComment extends Hydra implements ActivityCommentInterface {

    id?: number | null;

    activity?: ActivityInterface | string | null;

    createur?: UtilisateurInterface | string | null;

    dateCreation?: string | Date | null;

    dateModification?: string | Date | null;

    commentaire?: string = '';


    constructor(options: ActivityCommentInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
